import { render, staticRenderFns } from "./TextRecorder.vue?vue&type=template&id=3d6760a1"
import script from "./TextRecorder.vue?vue&type=script&lang=js"
export * from "./TextRecorder.vue?vue&type=script&lang=js"
import style0 from "./TextRecorder.vue?vue&type=style&index=0&id=3d6760a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports